<template>
  <div class="taobao-box">
    <div @click="$router.push('/taobao/search')">
 <vueSearch @onSearch="onSearch"></vueSearch>
    </div>
     <van-tabs @click="onTabChange" v-model="cat">
      <van-tab v-for="(item,index) in catList" :title="item.name" :key="index">
      </van-tab>
      </van-tabs>
      <recommendList></recommendList>
    <good v-for="(item,index) in goodList"
       :good="item"
      :key="index">
    </good>
    <van-button type="default" size="large" v-show="more" @click="loadMore">加载更多</van-button>
  </div>
</template>

<script>
  import good from '../../components/taobao/good'

export default {
  components:{
    good
  },
  data() {
    return {
      keyword: "",
      goodList: [],
      more: true, // 是否有分页
      page: 1,
      active: -1,
      cat:'', //分类tab的值
      cart:'', //分类id
      catList:[
        {name:'综合',value:'9660'},
        {name:'女装',value:'9658'},
        {name:'美妆个护',value:'9653'},
        {name:'食品',value:'9649'},
        {name:'家居家装',value:'9655'},
        {name:'男装',value:'9654'},
        {name:'运动户外',value:'9651'},
        {name:'数码家电',value:'9656'},
        {name:'内衣',value:'9652'},
        {name:'鞋包配饰',value:'9648'},
        {name:'母婴',value:'9650'},
      ], //分类列表
    };
  },
  created() {
    this.Post({}, "/taobao/dgOptimusMaterial", res => {
      if (res.states == 1) {
        let Data = res.data.result_list.map_data;
        this.goodList = Data;
      }
    });
  },
  methods: {
    // 获取数据
    getData(data) {
      this.Post(data, "/taobao/dgOptimusMaterial", res => {
        if (res.states == 1) {
          let good = res.data.result_list.map_data;
          if(good.length === 0){
            this.more = false
          }
          this.goodList = this.goodList.concat(good);
        }
      });
    },
    // 搜索
    onSearch(keyword) {
      this.goodList = [];
      this.page = 1;
      this.total_results=0;
      this.keyword = keyword;
      let data = {
        q: keyword,
        platform: this.$store.state.platform
      };
      this.getData(data);
    },
    // pc端领券购买
    goBuy(url) {
      window.open(url);
    },
    // 复制淘口令
    doCopy(item) {
      let url = "https:" + item.coupon_share_url;
      if (item.coupon_share_url == undefined) {
        url = item.coupon_click_url;
      }
      this.Post(
        {
          text: item.title,
          url: url,
          logo: item.pict_url
        },
        "/taobao/createTpwd",
        res => {
          if (res.states == 1) {
            let model = res.data.data.model;
            this.$router.push("/taobao/share?code=" + model);
          }
        }
      );
    },
    // 加载更多
    loadMore() {
      if (this.more) {
        this.page++;
        let data = {
          page: this.page,
          q: this.keyword,
          platform: this.$store.state.platform,
          cart:this.cart
        };
        this.getData(data);
      }
    },
     // 分类搜索
    onTabChange(index,title){
      const val = this.catList[index].value
      this.goodList = []
      this.more = true
      this.cart = val
      this.Post({cart:val}, "/taobao/dgOptimusMaterial", res => {
      if (res.states == 1) {
        let Data = res.data.result_list.map_data;
        this.goodList = Data;
      }
    });
    },
    // 排序筛选
    doSort(index, title) {
      let type = "tk_rate_des";
      //排序_des（降序），排序_asc（升序） 销量（total_sales），淘客佣金比率（tk_rate）， 累计推广量（tk_total_sales），总支出佣金（tk_total_commi），价格（price
      switch (title) {
        case "默认排序":
          type = "tk_rate_des";
          break;
        case "价格低":
          type = "price_asc";
          break;
        case "价格高":
          type = "price_des";
          break;
        case "销量":
          type = "total_sales_des";
          break;
        default:
          type = "tk_rate_des";
          break;
      }
      this.page = 1;
      this.total_results=0;
      this.goodList = [];
      let data = {
        q: this.keyword,
        platform: this.$store.state.platform,
        sort: type,
        cart:this.cart
      };
      this.getData(data);
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.taobao-box {
}
</style>



// WEBPACK FOOTER //
// src/pages/taobao/index.vue